/**
 * 챗봇 백엔드 API 클라이언트 (medilawyer-chatbot-service).
 *
 * same-origin 호출 — nginx 가 dev.medilawyer.co.kr/chat/* 를 :48082 로 라우팅.
 * 쿠키(medilawyer_session_id)는 credentials: 'include' 로 자동 동봉.
 */

async function request(path, options = {}) {
  const res = await fetch(path, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
    ...options,
  });
  if (!res.ok) {
    let detail = '';
    try {
      detail = await res.text();
    } catch {
      // ignore
    }
    const msg = detail.slice(0, 300) || res.statusText;
    throw new Error(`chatApi ${path} → ${res.status}: ${msg}`);
  }
  return res.json();
}

export const chatApi = {
  createSession: ({ fresh = false } = {}) =>
    request('/chat/sessions', { method: 'POST', body: JSON.stringify({ fresh }) }),

  getSession: (id) => request(`/chat/sessions/${id}?include_messages=true`),

  sendMessage: (id, text) =>
    request(`/chat/sessions/${id}/messages`, {
      method: 'POST',
      body: JSON.stringify({ text }),
    }),

  submitHotline: (id, phone, summary) =>
    request(`/chat/sessions/${id}/hotline`, {
      method: 'POST',
      body: JSON.stringify({ phone, summary: summary || null }),
    }),

  closeSession: (id) => request(`/chat/sessions/${id}/close`, { method: 'POST' }),

  getUsage: () => request('/chat/usage'),

  sendTyping: (id, actor) =>
    fetch(`/chat/sessions/${id}/typing`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ actor }),
    }),
};
